import fonts from './fonts';
import COLORS from './colors';

const baseStyles = {
  styleOverrides: {
    body: {
      overflowY: 'auto',
      overflowX: 'hidden',

      '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb, &::-webkit-scrollbar': {
        width: 3,
        height: 3,
        background: '#fff',
        borderRadius: 10,
        cursor: 'pointer'
      },

      '&::-webkit-scrollbar-thumb': {
        background: '#4F77DE'
      }
    },
    ul: {
      listStyle: 'none',
      margin: 0,
      padding: 0
    },
    fonts,
    '*': {
      fontFamily: 'Poppins, Arial, sans-serif',
    },
    '.read-only': {
      '& .MuiFormLabel-root': {
        transition: 'unset'
      },
      '& .MuiInputBase-root': {
        '&:after, &:before': {
          display: 'none'
        }
      },
      'div:nth-of-type(2)': {
        '&:after, &:before': {
          display: 'none'
        }
      },
      'input': {
        backgroundColor: 'inherit',
      }
    }
  }
};

export default baseStyles;
